import React, { useState, useEffect } from 'react'
import { getEventDataByAggregatorIdbyName, updateEventDataByAggregatorId } from '../../ActionCreator'
import { getAggregatorPayout, addAggregatorPayoutSlab, updateAggregatorPayoutSlab, deleteAggregatorPayoutSlab } from '../../../maketingComponents/actioncreator'
import Loader from '../../../../../presentationals/Loader/Loader.component'
import Popup from '../../../../../presentationals/Popup/Popup.component'

// ── Shared inline styles ────────────────────────────────────────────────────
const overlayStyle = {
    position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.45)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999,
}
const modalStyle = {
    background: '#fff', borderRadius: '12px', width: '600px', maxWidth: '95vw',
    maxHeight: '90vh', display: 'flex', flexDirection: 'column',
    boxShadow: '0 20px 60px rgba(0,0,0,0.2)', overflow: 'hidden',
}
const modalHeaderStyle = {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: '16px 20px', borderBottom: '1px solid #e5e7eb', flexShrink: 0,
}
const modalBodyStyle = { overflowY: 'auto', padding: '20px', flex: 1 }
const modalFooterStyle = {
    display: 'flex', justifyContent: 'flex-end', gap: '10px',
    padding: '14px 20px', borderTop: '1px solid #e5e7eb', flexShrink: 0, background: '#fff',
}
const fieldGroupStyle = { marginBottom: '16px' }
const labelStyle = { display: 'block', fontSize: '12px', fontWeight: 600, color: '#6b7280', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.04em' }
const inputStyle = {
    width: '100%', padding: '8px 12px', border: '1px solid #d1d5db',
    borderRadius: '8px', fontSize: '14px', color: '#111827', outline: 'none',
    boxSizing: 'border-box', transition: 'border-color 0.2s',
}
const editBtnStyle = {
    border: 'none', background: '#EEF2FF', color: '#4F46E5',
    borderRadius: '6px', padding: '5px 14px', fontSize: '12px',
    fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px',
}
const addBtnStyle = {
    border: 'none', background: '#4F46E5', color: '#fff',
    borderRadius: '6px', padding: '5px 14px', fontSize: '12px',
    fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px',
}
const saveBtnStyle = {
    border: 'none', background: '#4F46E5', color: '#fff',
    borderRadius: '8px', padding: '8px 22px', fontSize: '14px',
    fontWeight: 600, cursor: 'pointer',
}
const cancelBtnStyle = {
    border: '1px solid #d1d5db', background: '#fff', color: '#374151',
    borderRadius: '8px', padding: '8px 22px', fontSize: '14px',
    fontWeight: 600, cursor: 'pointer',
}
const closeBtnStyle = {
    border: 'none', background: '#f3f4f6', borderRadius: '6px',
    width: '32px', height: '32px', cursor: 'pointer', fontSize: '18px',
    color: '#6b7280', display: 'flex', alignItems: 'center', justifyContent: 'center', lineHeight: 1,
}
const deleteBtnStyle = {
    border: 'none', background: '#FEE2E2', color: '#DC2626',
    borderRadius: '6px', padding: '5px 12px', fontSize: '12px',
    fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px',
}

// ── Reusable Field ──────────────────────────────────────────────────────────
function Field({ label, name, value, onChange, type = 'text' }) {
    return (
        <div style={fieldGroupStyle}>
            <label style={labelStyle}>{label}</label>
            <input
                type={type}
                name={name}
                value={value ?? ''}
                onChange={onChange}
                style={inputStyle}
                onFocus={e => (e.target.style.borderColor = '#4F46E5')}
                onBlur={e => (e.target.style.borderColor = '#d1d5db')}
            />
        </div>
    )
}

// ── Combined Basic + Organisation Edit Modal ────────────────────────────────
function CombinedEditModal({ data, aggregatorId, onClose, onSaved, setLoader }) {
    const [form, setForm] = useState({
        companyName:           data?.companyName           ?? '',
        contactPerson:         data?.contactPerson         ?? '',
        mobileNumber:          data?.mobileNumber          ?? '',
        email:                 data?.email                 ?? '',
        webAddress:            data?.webAddress            ?? '',
        registeredAddress:     data?.registeredAddress     ?? null,
        organizationContactNo: data?.organizationContactNo ?? '',
        uploadLogoUrl:         data?.uploadLogoUrl         ?? '',
        partnerName:           data?.partnerName           ?? '',
        marketingModule:       data?.marketingModule       ?? false,
        active:                data?.active                ?? true,
    })
    const [saving, setSaving] = useState(false)

    const onChange = e => {
        const { name, value, type, checked } = e.target
        setForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }))
    }

    const onSave = () => {
        setSaving(true)
        if (setLoader) setLoader(true)
        const body = {
            ...form,
            active: form.active === 'true' || form.active === true,
        }
        console.log('PUT updateEventDataByAggregatorId body:', body)
        updateEventDataByAggregatorId(aggregatorId, body, res => {
            setSaving(false)
            if (setLoader) setLoader(false)
            console.log('Update response:', res)
            if (onSaved) onSaved("Saved successfully")
            onClose()
        })
    }

    return (
        <div style={overlayStyle} onClick={onClose}>
            <div style={{ ...modalStyle, width: '680px' }} onClick={e => e.stopPropagation()}>
                <div style={modalHeaderStyle}>
                    <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: '#111827' }}>Edit Details</h3>
                    <button style={closeBtnStyle} onClick={onClose}>×</button>
                </div>
                <div style={modalBodyStyle}>
                    {/* ── Basic Details section ── */}
                    <p style={{ margin: '0 0 12px 0', fontSize: '12px', fontWeight: 700, color: '#4F46E5', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Basic Details</p>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 16px' }}>
                        <Field label="Aggregator Name"   name="companyName"     value={form.companyName}     onChange={onChange} />
                        <Field label="Partner Name"      name="partnerName"     value={form.partnerName}     onChange={onChange} />
                        <Field label="POC Name"          name="contactPerson"   value={form.contactPerson}   onChange={onChange} />
                        <Field label="POC Mobile Number" name="mobileNumber"    value={form.mobileNumber}    onChange={onChange} />
                        <Field label="POC Email"         name="email"           value={form.email}           onChange={onChange} type="email" />
                    </div>

                    {/* ── Organisation Details section ── */}
                    <p style={{ margin: '16px 0 12px 0', fontSize: '12px', fontWeight: 700, color: '#4F46E5', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Organisation Details</p>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 16px' }}>
                        <Field label="Contact Number"    name="organizationContactNo" value={form.organizationContactNo} onChange={onChange} />
                        <Field label="Website Link"      name="webAddress"            value={form.webAddress}            onChange={onChange} />
                        <Field label="Registered Address" name="registeredAddress"   value={form.registeredAddress ?? ''} onChange={onChange} />
                        <div style={fieldGroupStyle}>
                            <label style={labelStyle}>Status</label>
                            <select name="active" value={String(form.active)} onChange={onChange} style={inputStyle}>
                                <option value="true">Active</option>
                                <option value="false">Inactive</option>
                            </select>
                        </div>
                      
                    </div>
                </div>
                <div style={modalFooterStyle}>
                    <button style={cancelBtnStyle} onClick={onClose} disabled={saving}>Cancel</button>
                    <button style={{ ...saveBtnStyle, opacity: saving ? 0.7 : 1, cursor: saving ? 'not-allowed' : 'pointer' }} onClick={onSave} disabled={saving}>
                        {saving ? 'Saving…' : 'Save'}
                    </button>
                </div>
            </div>
        </div>
    )
}

// ── Payout Row Edit / Add Modal ─────────────────────────────────────────────────────────
const EMPTY_PAYOUT = {
    costModelType: '', payoutCycle: '', reflectDate: '', isActive: true,
    minAmountSlab: '', maxAmountSlab: '', minCountSlab: '', maxCountSlab: '',
    costModelValue: '', percentage: '', paymentAmount: 0, isPercentage: false,
}

function PayoutModal({ row, isAdd, aggregatorId, onClose, onSaved, setLoader }) {
    const [form, setForm] = useState(row ? { ...row } : { ...EMPTY_PAYOUT })
    const [saving, setSaving] = useState(false)

    const onChange = e => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }))

    const onSave = () => {
        setSaving(true)
        if (setLoader) setLoader(true)
        if (isAdd) {
            const body = {
                aggregatorId,
                costModelType:  form.costModelType  || '',
                payoutCycle:    form.payoutCycle     || '',
                reflectDate:    form.reflectDate     || '',
                isActive:       form.isActive === true || form.isActive === 'true',
                minCountSlab:   Number(form.minCountSlab)   || 0,
                maxCountSlab:   Number(form.maxCountSlab)   || 0,
                minAmountSlab:  Number(form.minAmountSlab)  || 0,
                maxAmountSlab:  Number(form.maxAmountSlab)  || 0,
                costModelValue: Number(form.costModelValue) || 0,
                percentage:     Number(form.percentage)     || 0,
            }
            console.log('POST addAggregatorPayoutSlab:', body)
            addAggregatorPayoutSlab(body, res => {
                setSaving(false)
                if (setLoader) setLoader(false)
                console.log('Add response:', res)
                if(res?.aggregatorId){

                    if (onSaved) onSaved("Added successfully")
                    }else{
                if(onSaved) onSaved("Error Updating")
                }
                onClose()
            })
        } else {
            const body = {
                id:             row?.id,
                aggregatorId,
                minCountSlab:   Number(form.minCountSlab)   || 0,
                maxCountSlab:   Number(form.maxCountSlab)   || 0,
                minAmountSlab:  Number(form.minAmountSlab)  || 0,
                maxAmountSlab:  Number(form.maxAmountSlab)  || 0,
                costModelValue: Number(form.costModelValue) || 0,
                paymentAmount:  Number(form.paymentAmount)  || 0,
                isPercentage:   form.isPercentage === true  || form.isPercentage === 'true',
                percentage:     Number(form.percentage)     || 0,
                reflectDate:    form.reflectDate            || '',
                isActive:       form.isActive === true || form.isActive === 'true',
            }
            console.log('PUT updateAggregatorPayoutSlab:', body)
            updateAggregatorPayoutSlab(body, res => {
                setSaving(false)
                if (setLoader) setLoader(false)
                console.log('Update response:', res)
                if(res?.aggregatorId){

                    if (onSaved) onSaved("Updated successfully")
                    }else{
                if(onSaved) onSaved("Error Updating")
                }
                onClose()
            })
        }
    }

    return (
        <div style={overlayStyle} onClick={onClose}>
            <div style={{ ...modalStyle, width: '560px' }} onClick={e => e.stopPropagation()}>
                <div style={modalHeaderStyle}>
                    <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: '#111827' }}>
                        {isAdd ? 'Add Payout Configuration' : 'Edit Payout Configuration'}
                    </h3>
                    <button style={closeBtnStyle} onClick={onClose}>×</button>
                </div>
                <div style={modalBodyStyle}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 16px' }}>
                        {isAdd && (
                            <>
                                <div style={fieldGroupStyle}>
                                    <label style={labelStyle}>Model (Cost Model Type)</label>
                                    <select name="costModelType" value={form.costModelType} onChange={onChange} style={inputStyle}>
                                        <option value="">Select Option</option>
                                        <option value="CPA">CPA</option>
                                        <option value="CPD">CPD</option>
                                        <option value="CPL">CPL</option>
                                        <option value="CPI">CPI</option>
                                        <option value="CPR">CPR</option>
                                    </select>
                                </div>
                                <div style={fieldGroupStyle}>
                                    <label style={labelStyle}>Payout Cycle</label>
                                    <select name="payoutCycle" value={form.payoutCycle} onChange={onChange} style={inputStyle}>
                                        <option value="">Select Option</option>
                                        <option value="monthly">Monthly</option>
                                        <option value="yearly">Yearly</option>
                                        <option value="daily">Daily</option>
                                    </select>
                                </div>
                            </>
                        )}
                        <Field label="Min Amount Slab"  name="minAmountSlab"  value={form.minAmountSlab}  onChange={onChange} />
                        <Field label="Max Amount Slab"  name="maxAmountSlab"  value={form.maxAmountSlab}  onChange={onChange} />
                        <Field label="Min Count Slab"   name="minCountSlab"   value={form.minCountSlab}   onChange={onChange} />
                        <Field label="Max Count Slab"   name="maxCountSlab"   value={form.maxCountSlab}   onChange={onChange} />
                        <Field label="Cost Model Value" name="costModelValue" value={form.costModelValue} onChange={onChange} />
                        <Field label="Percentage"       name="percentage"     value={form.percentage}     onChange={onChange} />
                        <Field label="Reflect Date" type="date" name="reflectDate" value={form.reflectDate} onChange={onChange} />
                        {!isAdd && (
                            <>
                                <Field label="Payment Amount" name="paymentAmount" value={form.paymentAmount} onChange={onChange} />
                                <div style={fieldGroupStyle}>
                                    <label style={labelStyle}>Is Percentage</label>
                                    <select name="isPercentage" value={String(form.isPercentage)} onChange={onChange} style={inputStyle}>
                                        <option value="true">Yes</option>
                                        <option value="false">No</option>
                                    </select>
                                </div>
                            </>
                        )}
                        <div style={fieldGroupStyle}>
                            <label style={labelStyle}>Is Active</label>
                            <select
                                name="isActive"
                                value={form.isActive === true || form.isActive === 'true' ? 'true' : 'false'}
                                onChange={e => setForm(prev => ({ ...prev, isActive: e.target.value === 'true' }))}
                                style={inputStyle}
                            >
                                <option value="true">Yes</option>
                                <option value="false">No</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div style={modalFooterStyle}>
                    <button style={cancelBtnStyle} onClick={onClose} disabled={saving}>Cancel</button>
                    <button
                        style={{ ...saveBtnStyle, opacity: saving ? 0.7 : 1, cursor: saving ? 'not-allowed' : 'pointer' }}
                        onClick={onSave}
                        disabled={saving}
                    >
                        {saving ? 'Saving…' : isAdd ? 'Add' : 'Save'}
                    </button>
                </div>
            </div>
        </div>
    )
}

// ── Main Component ──────────────────────────────────────────────────────────
export default function AggregatorInformation({ Data, aggregatorBasicData }) {
    console.log("aggregatorBasicData", aggregatorBasicData)
    const [loader, setLoader] = useState(false)
    const [tableData, settableData] = useState([])
    const [customData, setcustomData] = useState({})

    // Modal states
    const [showCombinedEdit, setShowCombinedEdit] = useState(false)
    const [payoutModal,      setPayoutModal]       = useState(null) // null | { row, isAdd }
    const [popup,            setPopup]             = useState({ show: false, popupStatus: "" })

    const closePopup = () => setPopup({ show: false, popupStatus: "" })

    useEffect(() => { datApi() }, [])

    const datApi = () => {
        setLoader(true)
        getEventDataByAggregatorIdbyName(Data?.id ?? "", callback => {
            setLoader(false)
            setcustomData(callback ?? {})
        })
        getAggregatorPayout(Data?.id ?? "", callback => {
            setLoader(false)
            settableData(callback?.slabDetail ?? {})
        })
    }

    // ── SVG icon (reused in card headers) ──────────────────────────────────
    const CardIcon = () => (
        <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="37" height="37" rx="10" fill="#F5A676" fillOpacity="0.48" />
            <path fillRule="evenodd" clipRule="evenodd" d="M8.47489 8.08294C7.36232 8.27475 6.53256 9.02583 6.19543 10.1463C5.93028 11.0273 5.937 24.2917 6.20302 25.1875C6.43821 25.9791 7.11719 26.7703 7.92905 27.1986L8.56775 27.5354L19.1272 27.5693L29.6866 27.6031L30.3336 27.2864C31.6925 26.6216 32 25.8036 32 22.8541C31.9924 20.1303 31.9854 18.0696 31.9758 16.5072C31.9466 11.7591 31.8929 11.6115 31.7206 11.4393C31.3938 11.1124 30.8022 11.1194 30.4907 11.4537C30.3571 11.5971 30.2936 11.7432 30.2635 14.3086C30.2443 15.9395 30.2386 18.5482 30.2369 22.7554C30.1918 25.004 30.1181 25.201 29.1336 25.7045L28.5815 25.9868L18.8232 25.9531C9.70107 25.9217 9.03826 25.9049 8.65551 25.6958C8.43026 25.5728 8.13677 25.2932 8.00338 25.0742C7.77055 24.6925 7.76061 24.4015 7.76024 17.8888L7.75974 11.1013L8.03943 10.6903C8.19333 10.4643 8.477 10.1624 8.67005 10.0193C9.01812 9.76136 9.09929 9.759 18.8012 9.72469C29.4783 9.6869 29.2198 9.67124 29.8991 10.3936C30.1955 10.709 30.1979 10.7332 30.2597 14.1011C30.261 14.1716 30.2622 14.2408 30.2635 14.3086C30.3295 17.8833 30.3484 17.9015 31.138 17.9015C31.7369 17.9015 31.9201 17.8462 31.9758 16.5072C31.998 15.9757 32 15.242 32 14.2293C32 10.4479 31.931 10.1091 30.9631 9.14119C29.7766 7.95478 30.5232 8.02626 19.0719 8.00214C13.5681 7.99058 8.79946 8.027 8.47489 8.08294ZM13.0083 14.4877C11.9534 15.0211 11.3783 15.9812 11.3729 17.2178C11.3698 17.9157 11.7114 18.7852 12.182 19.2777L12.4875 19.5974L11.8797 19.9913C11.1661 20.4536 10.7238 20.9987 10.2858 21.9552C9.91501 22.7651 10.0094 23.2468 10.5388 23.2468C10.8978 23.2468 11.0334 23.092 11.2426 22.4434C11.4945 21.6622 12.5453 20.6976 13.4216 20.4427C14.3252 20.1801 15.3645 20.257 16.139 20.6437C16.9774 21.0625 17.414 21.5992 17.8841 22.7887C18.0541 23.2191 18.1091 23.2593 18.4784 23.2238C18.8346 23.1895 18.8901 23.1354 18.9236 22.7906C18.9985 22.0185 17.9613 20.4626 16.9776 19.8715C16.7279 19.7215 16.5021 19.5823 16.4759 19.5623C16.4497 19.5422 16.5976 19.333 16.8046 19.0972C17.3119 18.5194 17.493 17.9066 17.4335 16.97C17.3687 15.9537 16.8845 15.1372 16.0351 14.612C15.5395 14.3056 15.2681 14.2299 14.5466 14.1966C13.7891 14.1617 13.5717 14.2028 13.0083 14.4877ZM21.1851 14.4208C20.846 14.76 20.8731 15.0988 21.2641 15.4062C21.5715 15.6481 21.7497 15.6639 24.1685 15.6639C26.5873 15.6639 26.7656 15.6481 27.073 15.4062C27.455 15.1058 27.4974 14.6713 27.1732 14.378C26.9761 14.1996 26.58 14.1722 24.1898 14.1722C21.5994 14.1722 21.4188 14.1871 21.1851 14.4208ZM15.3033 15.7296C16.7075 16.6497 16.0446 18.896 14.3689 18.896C13.4209 18.896 12.6016 17.8279 12.7879 16.8349C12.8794 16.3474 13.5686 15.5887 14.001 15.4995C14.4114 15.4147 14.9746 15.5143 15.3033 15.7296ZM21.558 17.6132C20.9258 17.8577 20.7545 18.4441 21.1982 18.8456C21.4386 19.0633 21.6794 19.0824 24.1685 19.0824C26.6577 19.0824 26.8985 19.0633 27.1389 18.8456C27.4728 18.5434 27.4729 18.13 27.1391 17.8275C26.902 17.6126 26.6405 17.5885 24.3111 17.566C22.8995 17.5523 21.6606 17.5736 21.558 17.6132ZM21.2641 21.8885C20.8731 22.1959 20.846 22.5347 21.1851 22.8739C21.4186 23.1073 21.5994 23.1225 24.1408 23.1225C26.3898 23.1225 26.8948 23.0898 27.1242 22.9289C27.4989 22.6666 27.4761 22.2054 27.073 21.8885C26.7656 21.6465 26.5873 21.6308 24.1685 21.6308C21.7497 21.6308 21.5715 21.6465 21.2641 21.8885Z" fill="black" />
            <path d="M31.9758 16.5072C31.9466 11.7591 31.8929 11.6115 31.7206 11.4393C31.3938 11.1124 30.8022 11.1194 30.4907 11.4537C30.3571 11.5971 30.2936 11.7432 30.2635 14.3086C30.3295 17.8833 30.3484 17.9015 31.138 17.9015C31.7369 17.9015 31.9201 17.8462 31.9758 16.5072Z" fill="black" />
        </svg>
    )

    // ── Pencil icon ─────────────────────────────────────────────────────────
    const PencilIcon = () => (
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
        </svg>
    )

    return (
        <>
            {loader ? <Loader /> : ""}

            {/* ── Combined Edit Modal (Basic + Organisation) ── */}
            {showCombinedEdit && (
                <CombinedEditModal
                    data={customData}
                    aggregatorId={Data?.id ?? ''}
                    onClose={() => setShowCombinedEdit(false)}
                    onSaved={(msg) => {
                        datApi()
                        setPopup({ show: true, popupStatus: msg })
                    }}
                    setLoader={setLoader}
                />
            )}

            {/* ── Payout Add/Edit Modal ── */}
            {payoutModal && (
                <PayoutModal
                    row={payoutModal.row}
                    isAdd={payoutModal.isAdd}
                    aggregatorId={Data?.id ?? ''}
                    onClose={() => setPayoutModal(null)}
                    onSaved={(msg) => {
                        datApi()
                        setPopup({ show: true, popupStatus: msg })
                    }}
                    setLoader={setLoader}
                />
            )}

            <div className='OverView-Main-Section min-size-marketing-1800'>
                <div className="row">

                    {/* ── Basic Details Card ───────────────────────────────── */}
                    <div className="col-sm-7 col-xs-12">
                        <div className="info-cards" style={{ marginTop: '30px' }}>
                            <div className="topHeads" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <CardIcon />
                                    <h5 style={{ margin: 0 }}>Basic Details</h5>
                                </div>
                                <button style={editBtnStyle} onClick={() => setShowCombinedEdit(true)}>
                                    <PencilIcon /> Edit
                                </button>
                            </div>

                            <div className="row" style={{ marginTop: '25px' }}>
                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '15px' }}>
                                    <div className="info-text">
                                        <h5>Aggregator Name:</h5>
                                        <h6>{customData?.companyName ?? ""}</h6>
                                    </div>
                                </div>
                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '15px' }}>
                                    <div className="info-text">
                                        <h5>POC Mobile Number:</h5>
                                        <h6>{customData?.mobileNumber ?? ""}</h6>
                                    </div>
                                </div>
                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '15px' }}>
                                    <div className="info-text">
                                        <h5>POC Email:</h5>
                                        <h6>{customData?.email ?? ""}</h6>
                                    </div>
                                </div>
                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '15px' }}>
                                    <div className="info-text">
                                        <h5>Partner Name:</h5>
                                        <h6>{customData?.partnerName ?? ""}</h6>
                                    </div>
                                </div>
                            </div>
                            <div className="row" style={{ marginBottom: '25px' }}>
                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '15px' }}>
                                    <div className="info-text">
                                        <h5>Password:</h5>
                                        <h6>{customData?.password ?? ""}</h6>
                                    </div>
                                </div>
                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '15px' }}>
                                    <div className="info-text">
                                        <h5>Aggregator Type:</h5>
                                        <h6>{customData?.type ?? ""}</h6>
                                    </div>
                                </div>
                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '15px' }}>
                                    <div className="info-text">
                                        <h5>POC Name:</h5>
                                        <h6>{customData?.contactPerson ?? ""}</h6>
                                    </div>
                                </div>
                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '15px' }}>
                                    <div className="info-text">
                                        <h5>Creator Mode:</h5>
                                        <h6>{customData?.creatorMode ?? ""}</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ── Configuration Detail Card ─────────────────────────── */}
                    <div className="col-sm-5 col-xs-12">
                        <div className="info-cards" style={{ marginTop: '30px' }}>
                            <div className="topHeads">
                                <CardIcon />
                                <h5>Configuration Detail</h5>
                            </div>

                            <div className="row" style={{ marginTop: '25px' }}>
                                <div className="col-sm-6 col-xs-12" style={{ marginTop: '15px' }}>
                                    <div className="info-text">
                                        <h5>Payout Model:</h5>
                                        <h6>{aggregatorBasicData?.crmMappingKey ?? ""}</h6>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-xs-12" style={{ marginTop: '15px' }}>
                                    <div className="info-text">
                                        <h5>Payout Cycle:</h5>
                                        <h6>{customData?.payoutCycle ?? "Monthly"}</h6>
                                    </div>
                                </div>
                            </div>
                            <div className="row" style={{ marginBottom: '25px' }}>
                                <div className="col-sm-6 col-xs-12" style={{ marginTop: '15px' }}>
                                    <div className="info-text">
                                        <h5>POC Email:</h5>
                                        <h6>{customData?.email ?? ""}</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">

                    {/* ── Organisation Detail Card ──────────────────────────── */}
                    <div className="col-sm-4 col-xs-12">
                        <div className="info-cards" style={{ marginTop: '30px' }}>
                            <div className="topHeads" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <CardIcon />
                                    <h5 style={{ margin: 0 }}>Organisation Detail</h5>
                                </div>
                                <button style={editBtnStyle} onClick={() => setShowCombinedEdit(true)}>
                                    <PencilIcon /> Edit
                                </button>
                            </div>

                            <div className="row" style={{ marginTop: '25px' }}>
                                <div className="col-sm-6 col-xs-12" style={{ marginTop: '15px' }}>
                                    <div className="info-text">
                                        <h5>Contact Number:</h5>
                                        <h6>{customData?.organizationContactNo ?? ""}</h6>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-xs-12" style={{ marginTop: '15px' }}>
                                    <div className="info-text">
                                        <h5>Status:</h5>
                                        <h6>{customData?.active === true ? "Active" : "Inactive"}</h6>
                                    </div>
                                </div>
                            </div>
                            <div className="row" style={{ marginBottom: '25px' }}>
                                <div className="col-sm-6 col-xs-12" style={{ marginTop: '15px' }}>
                                    <div className="info-text">
                                        <h5>Website Link:</h5>
                                        <h6>{customData?.webAddress ?? ""}</h6>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-xs-12" style={{ marginTop: '15px' }}>
                                    <div className="info-text">
                                        <h5>Logo:</h5>
                                        <h6>{customData?.uploadLogoUrl ?? ""}</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ── Payout Configurations Table ───────────────────────── */}
                    <div className="col-sm-8 col-xs-12">
                        <div className="customDash-table" style={{ marginTop: '30px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                                <h5 style={{ margin: 0 }}>Payout Configurations</h5>
                                <button
                                    style={{...addBtnStyle,marginRight:'5px'}}
                                    onClick={() => setPayoutModal({ row: null, isAdd: true })}
                                >
                                    <svg style={{width:'auto'}} width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                        <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
                                    </svg>
                                    Add New
                                </button>
                            </div>
                            <div className='main-customized-table'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th>Min Slab</th>
                                            <th>Max Slab</th>
                                            <th>Cost Model Value</th>
                                            <th>Percentage</th>
                                            <th>Reflect Date</th>
                                            <th>Is Active</th>
                                            <th>Added on</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {tableData?.length > 0
                                            ? tableData?.map((value, id) => (
                                                <tr key={id}>
                                                    <td className="text-center">
                                                        {value?.costModelType === "CPA" || value?.costModelType === "CPD"
                                                            ? value?.minAmountSlab : value?.minCountSlab}
                                                    </td>
                                                    <td className="text-center">
                                                        {value?.costModelType === "CPA" || value?.costModelType === "CPD"
                                                            ? value?.maxAmountSlab : value?.maxCountSlab}
                                                    </td>
                                                    <td className="text-center">{value?.costModelValue || "-"}</td>
                                                    <td className="text-center">{value?.percentage || "-"}</td>
                                                    <td className="text-center">{value?.reflectDate || "-"}</td>
                                                    <td className="text-center">{value?.isActive === true ? "Yes" : "No"}</td>
                                                    <td className="text-center">{value?.addedOn || "-"}</td>
                                                    <td className="text-center">
                                                        <div style={{ display: 'flex', gap: '6px', justifyContent: 'center' }}>
                                                            <button
                                                                style={editBtnStyle}
                                                                onClick={() => setPayoutModal({ row: value, isAdd: false })}
                                                            >
                                                                <PencilIcon /> Edit
                                                            </button>
                                                            <button
                                                                style={deleteBtnStyle}
                                                                onClick={() => {
                                                                    setLoader(true)
                                                                    deleteAggregatorPayoutSlab(value?.id, res => {
                                                                        setLoader(false)
                                                                        console.log('Delete response:', res)
                                                                        datApi()
                                                                        if (res == "Deleted Successfully") {
                                                                            setPopup({ show: true, popupStatus: "Deleted successfully" })
                                                                        } else {
                                                                            setPopup({ show: true, popupStatus: "Error Deleting!" })
                                                                        }
                                                                    })
                                                                }}
                                                            >
                                                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                                    <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>
                                                                </svg>
                                                                Delete
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                            : (
                                                <tr>
                                                    <td colSpan={8} style={{ textAlign: 'center', color: '#9ca3af', padding: '24px 0' }}>
                                                        No payout configurations found.
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {popup.show && <Popup popupStatus={popup.popupStatus} closePopup={closePopup} />}
        </>
    )
}
